import { HStack, Text } from '@chakra-ui/react';
import React from 'react';
import GabStatus from './GabStatus';

type Props = {
  status: boolean,
  numberOfGAB?: number,
};

const GabInformations: React.FC<Props> = ({ status, numberOfGAB }) => {
  return (
    <HStack alignItems={'center'}>
      <Text>{numberOfGAB || 0}</Text>
      <GabStatus status={status} />
    </HStack>
  );
};

export default GabInformations;
